.c3{flex-shrink:0;}